import styled from 'styled-components';
import CustomIconButton from '../CustomIconButton';
import { IToken } from 'store/ducks/globalTypes';
import TextBox from '../TextBox';
import { themesList } from 'constants/themesList';

const DARK_THEMES = Object.keys(themesList).filter(
  (t) =>
    (themesList[t as keyof typeof themesList] as any).needsBlackText === true
) as (keyof typeof themesList)[];

const isDarkTheme = (scheme?: string) =>
  DARK_THEMES.includes(scheme as keyof typeof themesList);

const getDarkThemeBackground = (scheme?: string) =>
  isDarkTheme(scheme)
    ? `${
        Object.values(themesList).find((t) => t.mainColor === '#000000')
          ?.colorFillContent
      } !important`
    : 'transparent';

interface IContainer extends IToken {
  clnReqsExist: boolean;
}

export const StyledContainer = styled('div')<IContainer>`
  display: flex;
  flex-direction: ${(props) =>
    props.clnReqsExist ? 'column' : 'column-reverse'};
  align-items: stretch;
  gap: 10px;
  width: fit-content;
  max-width: 100%;
`;

export const StyledButtonSection = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => `${props.token.marginSM}px`};
`;

export const StyledDiv = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: fit-content;
`;

export const StyledCustomIconButton = styled(CustomIconButton)<IToken>`
  margin-top: ${(props) => `${props.token.marginXXS}px`};
  flex-shrink: 0;
`;

export const ButtonContainer = styled('div')<{
  withCheckbox?: boolean;
}>`
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  padding-left: 8px;
`;

export const StyledTextBox = styled(TextBox)`
  visibility: hidden;
`;

export const Container = styled('div')`
  // padding-right: 16px;
`;

export const TextAreaContainer = styled('div')<{ scheme?: string }>`
  flex-shrink: 0;
  background: ${({ scheme }) => getDarkThemeBackground(scheme)};
`;

export const FormattedContent = styled('div')`
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background: #fafafa;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
  word-break: break-word;
  white-space: pre-wrap;

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  a {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #40a9ff;
    }
  }

  ul,
  ol {
    margin: 8px 0;
    padding-left: 24px;
  }

  li {
    margin: 4px 0;
  }
`;
